import useEntryContent from './useEntryContent';
import home from '../queries/home';

const useHomeContent = () => useEntryContent('home', home.main);

export default useHomeContent;
